import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  inject,
} from '@angular/core';
import { SideMenuService } from '../../services/side-menu.service';
import { MeService } from 'src/app/me/services/me.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { LokaliseTranslatePipe } from '../../../lokalise/lokalise-translate.pipe';
import { AnalyticsModule } from '@geneplanet/ngx-utils';
import { ResultsMenuComponent } from '../../pages/results-menu/results-menu.component';

@UntilDestroy()
@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ResultsMenuComponent, AnalyticsModule, LokaliseTranslatePipe],
  host: { '[class.collapsed]': 'collapsed', '[class.opened]': 'opened' },
})
export class SideMenuComponent implements OnInit, AfterViewInit {
  private elementRef = inject(ElementRef);
  private sideMenuService = inject(SideMenuService);
  private cdr = inject(ChangeDetectorRef);
  private meService = inject(MeService);

  collapsed = false;
  opened = true;

  public navigationLinks = [];
  public isCollapsable = false;
  public isHovered = false;

  ngOnInit() {
    this.meService.getFullProfile()?.subscribe();
    this.sideMenuService.isCollapsable$.subscribe(
      (collapsable) => (this.isCollapsable = collapsable)
    );

    this.sideMenuService.isHovered$
      .pipe(untilDestroyed(this))
      .subscribe((hovered) => (this.isHovered = hovered));

    this.sideMenuService.state$
      .pipe(untilDestroyed(this))
      .subscribe((state) => {
        this.opened = state.opened;
        this.collapsed = state.collapsed;
        this.cdr.markForCheck();
      });
  }

  ngAfterViewInit() {
    this.sideMenuService.setSideMenuElementRef(this.elementRef);
  }

  toggleCollapsed() {
    this.sideMenuService.collapsedToggle();
  }

  onNavItemClicked() {
    this.sideMenuService.setDefault();
  }
}
